"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateGetParameter = exports.getParameter = exports.Policy = exports.Docs = exports.Activate = exports.ResetPassword = exports.Register = exports.MenuTree = exports.AuthTemplate = exports.Footer = exports.Table = exports.Pagination = exports.Sidebar = exports.RegisterForm = exports.Menu = exports.LoginForm = exports.Layout = exports.Typography = exports.Tooltip = exports.Textarea = exports.Tabs = exports.Select = exports.Radiobutton = exports.Paper = exports.Input = exports.Dialog = exports.Container = exports.Colors = exports.Code = exports.Chip = exports.Checkbox = exports.Button = exports.BottomNav = exports.Autocomplete = exports.Accordion = exports.Avatar = exports.Edges = exports.Theme = exports.useScrollDirection = exports.useScrollPosition = exports.useInterval = exports.useWindowResize = exports.useKeyPress = exports.SIDEBAR_WIDTH = exports.NAV_WIDTH = exports.HEADER_HEIGHT = exports.colors = exports.mui = exports.breakpoints = exports.bp = void 0;
exports.copyToClipboard = exports.parseNumber = exports.validateEmail = exports.setLocalStorage = exports.getLocalStorage = exports.getScrollBarWidth = void 0;
// Theme
const theme_1 = require("./theme");
Object.defineProperty(exports, "bp", { enumerable: true, get: function () { return theme_1.bp; } });
Object.defineProperty(exports, "breakpoints", { enumerable: true, get: function () { return theme_1.breakpoints; } });
Object.defineProperty(exports, "mui", { enumerable: true, get: function () { return theme_1.mui; } });
Object.defineProperty(exports, "colors", { enumerable: true, get: function () { return theme_1.colors; } });
Object.defineProperty(exports, "HEADER_HEIGHT", { enumerable: true, get: function () { return theme_1.HEADER_HEIGHT; } });
Object.defineProperty(exports, "NAV_WIDTH", { enumerable: true, get: function () { return theme_1.NAV_WIDTH; } });
Object.defineProperty(exports, "SIDEBAR_WIDTH", { enumerable: true, get: function () { return theme_1.SIDEBAR_WIDTH; } });
// Hooks
const useKeyPress_1 = __importDefault(require("./hooks/useKeyPress"));
exports.useKeyPress = useKeyPress_1.default;
const useWindowResize_1 = __importDefault(require("./hooks/useWindowResize"));
exports.useWindowResize = useWindowResize_1.default;
const useInterval_1 = __importDefault(require("./hooks/useInterval"));
exports.useInterval = useInterval_1.default;
const useScrollPosition_1 = __importDefault(require("./hooks/useScrollPosition"));
exports.useScrollPosition = useScrollPosition_1.default;
const useScrollDirection_1 = __importDefault(require("./hooks/useScrollDirection"));
exports.useScrollDirection = useScrollDirection_1.default;
// Elements
const avatar_1 = __importDefault(require("./components/elements/avatar"));
exports.Avatar = avatar_1.default;
const button_1 = __importDefault(require("./components/elements/button"));
exports.Button = button_1.default;
const checkbox_1 = __importDefault(require("./components/elements/checkbox"));
exports.Checkbox = checkbox_1.default;
const chip_1 = __importDefault(require("./components/elements/chip"));
exports.Chip = chip_1.default;
const code_1 = __importDefault(require("./components/elements/code"));
exports.Code = code_1.default;
const colors_1 = __importDefault(require("./components/elements/colors"));
exports.Colors = colors_1.default;
const container_1 = __importDefault(require("./components/elements/container"));
exports.Container = container_1.default;
const dialog_1 = __importDefault(require("./components/elements/dialog"));
exports.Dialog = dialog_1.default;
const container_2 = __importDefault(require("./components/elements/container"));
exports.Edges = container_2.default;
const input_1 = __importDefault(require("./components/elements/input"));
exports.Input = input_1.default;
const paper_1 = __importDefault(require("./components/elements/paper"));
exports.Paper = paper_1.default;
const radio_1 = __importDefault(require("./components/elements/radio"));
exports.Radiobutton = radio_1.default;
const select_1 = __importDefault(require("./components/elements/select"));
exports.Select = select_1.default;
const tabs_1 = __importDefault(require("./components/elements/tabs"));
exports.Tabs = tabs_1.default;
const textarea_1 = __importDefault(require("./components/elements/textarea"));
exports.Textarea = textarea_1.default;
const themeProvider_1 = __importDefault(require("./components/elements/themeProvider"));
exports.Theme = themeProvider_1.default;
const tooltip_1 = __importDefault(require("./components/elements/tooltip"));
exports.Tooltip = tooltip_1.default;
const typography_1 = __importDefault(require("./components/elements/typography"));
exports.Typography = typography_1.default;
// Combinations
const autoComplete_1 = __importDefault(require("./components/combinations/autoComplete"));
exports.Autocomplete = autoComplete_1.default;
const accordion_1 = __importDefault(require("./components/combinations/accordion"));
exports.Accordion = accordion_1.default;
const bottomNav_1 = __importDefault(require("./components/combinations/bottomNav"));
exports.BottomNav = bottomNav_1.default;
const layout_1 = __importDefault(require("./components/combinations/layout"));
exports.Layout = layout_1.default;
const loginForm_1 = __importDefault(require("./components/combinations/loginForm"));
exports.LoginForm = loginForm_1.default;
const menu_1 = __importDefault(require("./components/combinations/menu"));
exports.Menu = menu_1.default;
const menuTree_1 = __importDefault(require("./components/combinations/menuTree"));
exports.MenuTree = menuTree_1.default;
const registerForm_1 = __importDefault(require("./components/combinations/registerForm"));
exports.RegisterForm = registerForm_1.default;
const sidebar_1 = __importDefault(require("./components/combinations/sidebar"));
exports.Sidebar = sidebar_1.default;
const pagination_1 = __importDefault(require("./components/combinations/pagination"));
exports.Pagination = pagination_1.default;
const table_1 = __importDefault(require("./components/combinations/table"));
exports.Table = table_1.default;
const footer_1 = __importDefault(require("./components/combinations/footer"));
exports.Footer = footer_1.default;
const authTemplate_1 = __importDefault(require("./components/combinations/authTemplate"));
exports.AuthTemplate = authTemplate_1.default;
// Pages
const register_1 = __importDefault(require("./components/pages/register"));
exports.Register = register_1.default;
const resetPassword_1 = __importDefault(require("./components/pages/resetPassword"));
exports.ResetPassword = resetPassword_1.default;
const activate_1 = __importDefault(require("./components/pages/activate"));
exports.Activate = activate_1.default;
const docs_1 = __importDefault(require("./components/pages/docs"));
exports.Docs = docs_1.default;
const policies_1 = __importDefault(require("./components/pages/policies"));
exports.Policy = policies_1.default;
// Utils
const getParameter_1 = __importDefault(require("./utils/getParameter"));
exports.getParameter = getParameter_1.default;
const updateGetParameter_1 = __importDefault(require("./utils/updateGetParameter"));
exports.updateGetParameter = updateGetParameter_1.default;
const getScrollBarWidth_1 = __importDefault(require("./utils/getScrollBarWidth"));
exports.getScrollBarWidth = getScrollBarWidth_1.default;
const getLocalStorage_1 = __importDefault(require("./utils/getLocalStorage"));
exports.getLocalStorage = getLocalStorage_1.default;
const setLocalStorage_1 = __importDefault(require("./utils/setLocalStorage"));
exports.setLocalStorage = setLocalStorage_1.default;
const validateEmail_1 = __importDefault(require("./utils/validateEmail"));
exports.validateEmail = validateEmail_1.default;
const parseNumber_1 = __importDefault(require("./utils/parseNumber"));
exports.parseNumber = parseNumber_1.default;
const copyToClipboard_1 = __importDefault(require("./utils/copyToClipboard"));
exports.copyToClipboard = copyToClipboard_1.default;
